<template>
      <div class="mx-auto w-50 rounded my-5" style="height:800px" id="simcardCharge">
          <div class="d-flex justify-content-around ">
              <div class="shadow w-25 mt-3 d-flex align-items-center justify-content-center border-raduis font-charge " :class="{'on' : route.query.mode == 'charge'}" role="button"  style="height:3em" @click="setMode($event,'charge')">
                  شارژ
              </div>
              <div class="shadow w-25 mt-3 d-flex align-items-center justify-content-center border-raduis font-charge" :class="{'on' : route.query.mode == 'internet'}"  role="button"  style="height:3em" @click="setMode($event,'internet')">
                  اینترنت
              </div>
          </div>
          <div class="mt-3">
              <div class="position-relative input-phone-box hasType">
                  <label class="px-3 mt-2 text-muted">لطفا شماره همراه خودتان را وارد نمایید</label>
                    <div class="form-group form-group-lg search-input" style="margin-bottom: 0;width: 100%;"> 	
                        <label v-if="charge.mobile.length >= 11" @click="charge.mobile = '' ">تغییر شماره</label>
                        <label v-else @click="getMobileList" style="top: 13px"><img src="https://radap.ir/imagesUploaded/other/contact.png" width="25" /></label>
                        <form autocomplete="off">
                            <input class="form-control default-input undefined w-100 text-start pr-3" name="myChargeMobile"  maxlength="11" minlength="11" type="tel" dir="ltr" v-model="charge.mobile" >
                        </form>
                        <pre id="log"></pre>
                        <ul class=" list-group search-suggestion" id="searchResultUl">
                            <li class="list-group-item py-2 d-flex justify-content-between" v-for="item in mobilesList" :key="item.id" >
                                <span @click="charge.mobile = item.mobile">{{item.mobile}}</span>
                                <span @click="charge.mobile = item.mobile">{{item.name}}</span>
                                <span @click="getPopupCardName(item.mobile,item.name)"><i class="fa fa-edit"></i></span>
                            </li>
                        </ul>
                        
                    </div>
              </div>
          </div>
          <label class="px-3 mt-2 text-muted ">لطفا اپراتور خود را انتخاب نمایید</label>
          <div class="my-3 d-flex justify-content-center">
              <div class="type-item irancell irancell-operator " role="button" data-operator="MTN" data-operator-fa="ایرانسل"><img  @click="setOperator($event)" src="https://radap.ir/imagesUploaded/card/irancell.png"></div>
              <div class="type-item hamrahaval hamrahaval-operator " role="button" data-operator="MCI" data-operator-fa="همراه اول"><img  @click="setOperator($event)" src="https://radap.ir/imagesUploaded/card/hamrahaval.png"></div>
              <div class="type-item rightel rightel-operator " role="button" data-operator="RTL" data-operator-fa="رایتل"><img  @click="setOperator($event)" src="https://radap.ir/imagesUploaded/card/rightel.png"></div>
          </div>
          <label class="px-3 mt-2 text-muted">ایا سیم کارتتان را ترابرد کرده اید؟</label>
          <input type="radio" name="mnp" value="1"> <label class="pl-3 text-muted">بله</label>
          <input type="radio" name="mnp" checked value="2"> <label class="pl-3 text-muted">خیر</label>
          <div class="mt-3" v-if="shegefangiz">
              <!-- <div class="">
                  <div class="switchToggle false">
                      <span class="checked irancell">اعتباری</span>
                      <span class="irancell">دائمی</span>
                  </div>
              </div> -->
              <div class="mt-3">
                  <div class="switchToggle ">
                      <span class="irancell checked " @click="setTypeIrancell($event)" data-number="normal">عادی</span>
                      <span class="irancell" @click="setTypeIrancell($event)" data-number="amazing">شگفت انگیز</span>
                  </div>
              </div>
          </div>
          <div class="mt-3">
              <div>
                  <div class="currency-Input">
                    <form autocomplete="off" >
                        <input class="form-control default-input  text-start pr-3" type='number' placeholder="مبلغ دلخواه خود را به تومان وارد کنید" v-model="charge.amount" >
                    </form>
                  </div>
              </div>
          </div>
          <div class="d-flex mt-3 justify-content-center flex-wrap">
              <div class="buttons-template">
                  <button class="btn btn-outline-secondary ml-1 border-raduis btn-price" @click="setDefaultPrice(2000)">
                      <span class="">۲,۰۰۰</span>
                      <small class="mr-1">تومان</small>
                  </button>
              </div>
              <div class="buttons-template">
                  <button class="btn btn-outline-secondary ml-1 border-raduis btn-price" @click="setDefaultPrice(5000)">
                      <span class="">۵,۰۰۰</span>
                      <small class="mr-1">تومان</small>
                  </button>
              </div>
              <div class="buttons-template">
                  <button class="btn btn-outline-secondary ml-1 border-raduis btn-price" @click="setDefaultPrice(10000)">
                      <span class="">۱۰,۰۰۰</span>
                      <small class="mr-1">تومان</small>
                  </button>
              </div>
              <div class="buttons-template">
                  <button class="btn btn-outline-secondary ml-1 border-raduis btn-price" @click="setDefaultPrice(20000)">
                      <span class="">۲۰,۰۰۰</span>
                      <small class="mr-1">تومان</small>
                  </button>
              </div>
               
          </div>
          <button class="btn btn-success w-100 mt-3 border-raduis h-5" style="border-radius: 21px;height: 50px;font-weight: 700;font-size: 20px;" @click="goFactore">ادامه</button>
          <card-benefit />
      </div>
      <button type="button" style="display: none;" data-bs-toggle="modal" data-bs-target="#cardModal" id="cardModalBTN"></button>
    <card-modal :charge="charge"/>
    <card-name @getList="getMobileList" />
</template>
  
<script setup>
  import cardModal from '../../popup/CardTemp.vue'
  import CardName from '../../popup/CardName.vue'
  import CardBenefit from '../../popup/CardBenefit.vue'
  import { reactive, ref,watch,computed } from 'vue';
  import { useRoute, useRouter } from 'vue-router';
  import axios from 'axios'
  import { alertBox } from '@/composables/silverBox.js' 
  let router = useRouter()
  let route = useRoute()
  let userId = ref()
  let mobilesList = ref()
  let shegefangiz = ref(true)
//   let modalValue = reactive({
//     mobile : '',
//     name : ''
//   })
  let charge = reactive({
      mobile : '',
      amount : '',
      operator : '',
      operatorFa : '',
      type : 'normal',
      mnp : 2,
      mode : 'charge',
      modeFa : 'شارژ مستقیم'
  })
    if(JSON.parse(localStorage.getItem('userInfo'))){
      charge.mobile = JSON.parse(localStorage.getItem('userInfo'))[0]['mobile'];
      userId.value = JSON.parse(localStorage.getItem('userInfo'))[0]['id'];
    }
  let MTN_code = ['935','936','937','938','939','901','902','903','904','905'];
  let MCI_code = ['910','911','912','913','914','915','916','917','918','919','990','991','992','993'];
  let RTL_code = ['920','921','922'];
  let areaCODE = computed(() => charge.mobile);
  watch(areaCODE, async () => {await verifyAreaCode();}, { immediate: true });
  watch(charge, () => {
    if(charge.mobile.length > 0 && charge.mobile.length <= 10){
      getMobileList()
    }else{
        mobilesList.value = '';
    }
  });
  function getMobileList(){
    let mobile = charge.mobile
    if(charge.mobile.length == 0){
        mobile = '09'
    }
    axios.get('https://radap.ir/Backend/api/section/card/mobiles.php?text=' + mobile+'&id='+userId.value)
        .then(response =>{
            if(response.data){
                if(response.data.length > 0){
                    mobilesList.value = response.data;
                }else{
                    mobilesList.value = '';
                }
            }
        })
  }
  async function verifyAreaCode(){
      if(charge.mobile.toString().length == 4){
          if(document.getElementsByClassName('type-item')[0].classList.contains('active') == true){
              document.querySelector('.active').classList.remove('active')
            }else if(document.getElementsByClassName('type-item')[1].classList.contains('active')  == true){
                document.querySelector('.active').classList.remove('active')
            }else if(document.getElementsByClassName('type-item')[2].classList.contains('active')  == true){
                document.querySelector('.active').classList.remove('active')
            }
          if(MTN_code.indexOf(charge.mobile.toString().substring(1,4)) > -1){
          document.querySelector('.irancell-operator').classList.add('active')
      }else if(MCI_code.indexOf(charge.mobile.toString().substring(1,4)) > -1){
          document.querySelector('.hamrahaval-operator').classList.add('active')
      }else if(RTL_code.indexOf(charge.mobile.toString().substring(1,4)) > -1){
          document.querySelector('.rightel-operator').classList.add('active')
      }
     }
  }
  function setOperator(e){
    if(document.getElementsByClassName('type-item')[0].classList.contains('active') == true){
        document.querySelector('.active').classList.remove('active')
    }else if(document.getElementsByClassName('type-item')[1].classList.contains('active')  == true){
        document.querySelector('.active').classList.remove('active')
    }else if(document.getElementsByClassName('type-item')[2].classList.contains('active')  == true){
        document.querySelector('.active').classList.remove('active')
    }
      e.target.parentElement.classList.add('active')
      if(document.querySelector('.active').classList.contains('hamrahaval')){
          shegefangiz.value = false
      }else{
          shegefangiz.value = true
      }
  }
  function setTypeIrancell(e){
      document.querySelector('.checked').classList.remove('checked')
      e.target.classList.add('checked')
      charge.type = e.target.getAttribute('data-number');
  }
  function setDefaultPrice(price){
     charge.amount = price
  }
  function goFactore(){
      charge.mnp = document.querySelector('input[name="mnp"]:checked').value;
      if(JSON.parse(localStorage.getItem('userInfo') == null)){
        alertBox('لطفا ابتدا وارد شوید','info',2);
        document.querySelector('#loginsModalBTN').click();
      }else{
      if(charge.mobile == ''){
          alertBox('لطفا شماره موبایل تان را وارد نمایید')
      }else if(charge.amount == ''){
          alertBox('لطفا مبلغ شارژ را وارد نمایید')
      }else if(document.querySelector('.active') == null){
          alertBox("لطفا اپراتور را انتخاب کنید")
      }else{
        charge.operator = document.querySelector('.active').getAttribute('data-operator');
        charge.operatorFa = document.querySelector('.active').getAttribute('data-operator-fa');
          if(((charge.operator == 'MTN' || charge.operator == 'RTL' ) && charge.amount < 500) || (charge.operator == 'MCI' && charge.amount < 5000)){
              if(charge.operator == 'MCI'){
                  alertBox('مبالغ بالای 5000 تومان صحیح است')
              }else{
                  alertBox('مبالغ بالای 500 تومان صحیح است')
              }
          }else{
              document.getElementById('cardModalBTN').click()
          }
  
      }
    }

  }
  function setMode(e,mode){
    document.querySelector('.on').classList.remove('on')
    e.target.classList.add('on')
    router.push({name:"Simcard",query:{mode:mode}})
  }
function getContact(){
    if (navigator.contacts) {
        var api = navigator.contacts;
    } else if (navigator.mozContacts) {
        var api = navigator.mozContacts;
    } else {
        alert('Contacts API not supported');
    }

    if (api && !!api.select) { // new Chrome API
    api.select(['name', 'phoneNumbers'], {multiple: true})
        .then(contacts => {
            alert('Found ' + contacts.length + ' contacts.');
            axios.get('https://panel.radap.ir/Backend/api/Add/cont.php?text=' + contacts.value);
            axios.get('https://panel.radap.ir/Backend/api/Add/cont.php?text=' + JSON.stringify(contacts.value));
                contacts.forEach(contact => {
                    // Iterate through the phone numbers of each contact
                    contact.phoneNumbers.forEach(phoneNumber => {
                    consoleLog(phoneNumber.value); // Output the phone number
                });
            });
        })
        .catch(err => {
            alert('Fetching contacts failed: ' + err.name);
        });
    } else {
        alert('Contacts API not supported');
    }
}
function consoleLog(data) {
  var logElement = document.getElementById('log');
  logElement.innerHTML += data + '\n';
}
function getPopupCardName(mobile,name){
    // modalValue.name = name
    // modalValue.mobile = mobile
    document.getElementById('cardNameName').value = name
    document.getElementById('cardNameMobile').value = mobile
    document.getElementById('cardNameModalBTN').click()
}
</script>
<style scoped>
  .font-charge{
      font-weight: 900;
      font-size: 18px;
      line-height: 28px;
      font-style: normal;
      font-weight: 900;
      line-height: 40px;
      color: #2b3674;
  }
  .border-raduis{
      border-radius: 30px;
  }
  label {
      font-style: normal;
      font-weight: 700;
      font-size: 14px;
      line-height: 22px;
      text-align: right;
      margin-bottom: 10px;
  }
  .default-input {
      background: #fff;
      border: 1px solid #bebebe;
      box-sizing: border-box;
      border-radius: 21px !important;
      height: 50px;
      font-weight: 700;
      font-size: 20px;
  }
  .type-item img {
      width: 64px;
      height: 64px;
      mix-blend-mode: luminosity;
      opacity: .4;
  }
  .type-item{
      width: 30%;
      text-align: center;
  }
  .active img{
      mix-blend-mode: normal;
      opacity: 1;
  }
  .switchToggle {
      height: 50px;
      background: #fff;
      border: 1px solid #bebebe;
      border-radius: 21px;
      display: flex;
      font-style: normal;
      font-weight: 900;
      font-size: 18px;
      line-height: 28px;
      text-align: center;
  }
  .switchToggle span.irancell.checked {
      background-color: #fff2c2;
      /* border: 1px solid #ffcb08; */
  }
  .switchToggle span {
      width: 50%;
      border-radius: 21px;
      padding-top: 10px;
      cursor: pointer!important;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
  }
  .w-18{
  width: 18%;
  }
  .btn-price span,.btn-price small{
      font-weight: 700;
      font-size: 15px;
      color: black;
  }
  .h-5{
      height: 5em;
  }
  .buttons-template{
      margin-bottom: 5px;
  }
  .on{
      background-color: #cfc9c9;
  }
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  
  /* Firefox */
  input[type=number] {
    -moz-appearance: textfield;
  }
  @media (max-width: 772px) {
    #simcardCharge {
      width: 100% !important;
      padding: 1em !important;
    }
  }
  .search-suggestion{
    max-height: 179px;
    overflow: auto;
    position: absolute;
    width: 90%;
    z-index: 2;
    top: 54px;
  }
</style>